export default __webpack_public_path__ + "static/daydaylearn-44b588fa80fe3df3e9ddd9613aa06c7e.png";